// extracted by mini-css-extract-plugin
export var card = "_5v-1";
export var container = "_5v-0";